export default __webpack_public_path__ + "static/pop2-9abc3cb138847587077b8a16d53b61bf.webp";